import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextareaAutosize } from '@mui/material';
import { DocumentStatusModalProps } from '../types/contractor.types';

const DocumentStatusModal: React.FC<DocumentStatusModalProps> = ({
  open,
  status,
  onClose,
  onSubmit,
}) => {
  const [notes, setNotes] = useState('');

  const handleSubmit = () => {
    if (notes.trim()) {
      onSubmit(notes.trim());
      setNotes('');
    }
  };

  const handleClose = () => {
    setNotes('');
    onClose();
  };

  const getTitle = () => {
    return status === 3 ? 'Clarify Document' : 'Reject Document';
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{getTitle()}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Please provide notes for the action:
        </Typography>
        <TextareaAutosize
          minRows={4}
          placeholder="Enter notes here..."
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          style={{ 
            width: '100%', 
            padding: '8px', 
            borderRadius: '4px', 
            border: '1px solid #ccc',
            fontFamily: 'inherit'
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button 
          onClick={handleSubmit} 
          color="primary" 
          variant="contained" 
          disabled={!notes.trim()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentStatusModal;